export enum BUTTON_VARIANT {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  DISABLED = "DISABLED",
}

export enum BUTTON_ACTION {
  SEND_INVITE = "SEND_INVITE",
  REACTIVATE = "REACTIVATE",
  DEACTIVATE = "DEACTIVATE",
  UPLOAD_CSV = "UPLOAD_CSV",
  ADD_MEMBER = "ADD_MEMBER",
  ADD_ADMIN = "ADD_ADMIN",
  REMOVE_ADMIN = "REMOVE_ADMIN",
  ADD_DOMAIN = "ADD_DOMAIN",
  REMOVE_DOMAIN = "REMOVE_DOMAIN",
}

export enum LOCAL_STORAGE_KEYS {
  MEMBERS_PAGINATION_NUMBER = "membersPaginationPage",
  MEMBERS_TOTAL_PAGES = "membersTotalPages",
}
